import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { ACTION_CATEGORY, ACTION_NAME, ACTION_OBJECT } from "../../constants";
import { useUrlParams } from "../../hooks";
import { ActionService } from "../../services";
import { currentExperienceSelector } from "../../store/selectors";

export function useShareLinkTracking() {
  const [hasTrackedShareLink, setHasTrackedShareLink] = useState(false);

  const { propertyId, experienceId, userId } = useUrlParams();

  const { experience } = useSelector(currentExperienceSelector);
  const { sharedById, sharedContactId, shareUrl } = experience;

  const getIpAddress = () =>
    fetch("https://www.cloudflare.com/cdn-cgi/trace")
      .then((res) => res.text())
      .then((data) => /[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}/.exec(data)[0]);

  useEffect(() => {
    (async () => {
      const shareId = new URLSearchParams(location.search).get("shareId");

      if (shareId && !hasTrackedShareLink) {
        if (!sharedById) {
          return;
        }

        if (userId && userId === sharedById) {
          return;
        }

        try {
          const ipAddress = await getIpAddress();
          const values = {
            name: ACTION_NAME.VIEWED,
            category: ACTION_CATEGORY.ENGAGEMENT,
            object: ACTION_OBJECT.EXPERIENCE,
            objectName: experience.title,
            shareUrl,
            experienceId,
            propertyId,
            shareId: +shareId,
            to: [sharedById],
            ipAddress,
          };

          if (userId) {
            values.userId = userId;
          }

          if (sharedContactId) {
            values.contactId = sharedContactId;
          }

          await ActionService.addAction(values);
        } catch (error) {
          console.error(error);
        } finally {
          setHasTrackedShareLink(true);
        }
      }
    })();
  }, [hasTrackedShareLink, sharedById]);

  return { hasTrackedShareLink, setHasTrackedShareLink };
}
